<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-title-block">
    <div class="dialog-title-row">
      <div>
        <div class="dialog-title">{{ 'reserve.details.activity.boxId'|traduccion }} {{lockerId}}</div>
        <div class="dialog-subtitle">Trazabilidad de eventos y sincronizaciones asociados a la reserva.</div>
      </div>
      <span class="summary-pill">Total: {{activities.length}}</span>
    </div>
  </div>

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <mat-card class="detail-card">
    <div class="card-heading">
      <div>
        <h3>Linea temporal</h3>
        <p>Eventos capturados desde el sistema, pagos y taquilla.</p>
      </div>
      <div class="card-actions">
        <button
          mat-stroked-button
          class="refresh-button"
          type="button"
          [disabled]="isRefreshing"
          (click)="showActivities(orderUuid)">
          <mat-icon>refresh</mat-icon>
          Actualizar
        </button>
        <mat-icon>history</mat-icon>
      </div>
    </div>

    <div class="table-container">
      <app-data-table
        class="activity-desktop-view"
        preset="compact"
        [dataSource]="activities"
        [displayedColumns]="displayedColumns"
        [rowClass]="activityRowClass"
        tableClass="full-width activity-table">
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>{{'reserve.details.activity.table.header.description'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <strong>{{ activityDescription(element.domain, element.action) | traduccion }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>{{'reserve.details.activity.table.header.createdAt'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{element.createdAt | date: appService.FORMAT_DATETIME}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'reserve.details.activity.table.header.status'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <span class="mini-badge" *ngIf="element.status">{{'tracking.' + element.status | traduccion}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="who">
          <th mat-header-cell *matHeaderCellDef>{{'reserve.details.activity.table.header.who'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{element.who | traduccion}}</td>
        </ng-container>

      </app-data-table>

      <div class="activity-mobile-view" *ngIf="activities?.length; else noActivitiesMobile">
        <article
          class="activity-mobile-card"
          *ngFor="let element of activities"
          [ngClass]="activityRowClass(element)">
          <div class="activity-mobile-top">
            <strong class="activity-mobile-title">{{ activityDescription(element.domain, element.action) | traduccion }}</strong>
            <span class="mini-badge" *ngIf="element.status">{{'tracking.' + element.status | traduccion}}</span>
          </div>

          <div class="activity-mobile-grid">
            <div class="activity-mobile-item">
              <span class="activity-mobile-label">{{'reserve.details.activity.table.header.createdAt'|traduccion}}</span>
              <strong>{{element.createdAt | date: appService.FORMAT_DATETIME}}</strong>
            </div>
            <div class="activity-mobile-item" *ngIf="element.who">
              <span class="activity-mobile-label">{{'reserve.details.activity.table.header.who'|traduccion}}</span>
              <strong>{{element.who | traduccion}}</strong>
            </div>
          </div>
        </article>
      </div>

      <ng-template #noActivitiesMobile>
        <div class="activity-mobile-empty">
          No hay actividad registrada.
        </div>
      </ng-template>
    </div>
  </mat-card>
</mat-dialog-content>
